import React from "react";
import "./GroupHero.css";

export default function GroupHero(props) {
  const {
    title,
    subtitle,
    actions,
    showMascot = true,
    mascotImgSrc = `${process.env.PUBLIC_URL || ""}/images/logo/logo.png`,
    showMeadow = true,
    meadowIcons,
    className = "",
  } = props;

  const icons = Array.isArray(meadowIcons) ? meadowIcons.filter(Boolean) : [];
  const hasActions = !!actions || showMascot;

  return (
    <div className={`group-hero as-theme ${className}`.trim()}>
      <div className="group-hero-inner">
        <div className="flex-grow-1">
          <h3 className="group-hero-title">{title}</h3>
          {subtitle ? <div className="group-hero-subtitle">{subtitle}</div> : null}
        </div>

        {hasActions ? (
          <div className="group-hero-actions">
            {actions}
            {showMascot ? (
              <div className="group-hero-mascot" aria-hidden="true">
                <img
                  src={mascotImgSrc}
                  alt=""
                  className="group-hero-logo"
                  draggable="false"
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

      {showMeadow && icons.length > 0 ? (
        <div className="group-hero-meadow" aria-hidden="true">
          <div className="group-hero-meadow-icons">
            {icons.map((it, idx) => (
              <span key={idx}>{it}</span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}

